// extracted by mini-css-extract-plugin
export default {"cards":"InsightsCards_cards__N9-mN"};